function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Lib Imports
import React, { useContext, useMemo } from 'react';
import { Box, Text, Layer, ResponsiveContext, TextArea } from 'grommet';
import PropTypes from 'prop-types';
import { Formik } from 'formik';

// Core Imports
import Divider from 'granite-admin/core/components/Divider';
import FormField from 'granite-admin/core/components/FormField';

// Application Imports
import UploadComponent from './components/UploadComponent';
import { getCroppedImg, LayerFooter, LayerHeader } from './components/utils';
const UploadFile = ({
  className,
  setLayer,
  eventEmitter,
  uploadFile,
  accept,
  title,
  imageCropAspect,
  showAddNotes,
  initialNote,
  ...rest
}) => {
  const size = useContext(ResponsiveContext);
  // Define file types in string
  const fileTypes = useMemo(() => {
    let string = `${accept}`;
    string = string.toUpperCase().split(',').join(' ');
    if (string.length < 1) string = 'All file types are accepted';
    return string;
  }, [accept]);

  //TODO - complete this
  const onSubmit = async (values, {
    setSubmitting,
    setErrors
  }) => {
    setErrors({});
    setSubmitting(true);
    try {
      // TODO: cleanup
      if (imageCropAspect && values.ext !== 'gif') {
        getCroppedImg(values.imageRef, values.croppedAreaPixels, values.file_name, async croppedImage => {
          let obj = {
            ...values,
            files: [croppedImage]
          };
          await uploadFile(eventEmitter, obj);
        });
      } else {
        await uploadFile(eventEmitter, values);
      }
    } catch (e) {
      console.log(e);
      if (e.errors) setErrors(e.errors);
    }
    setSubmitting(false);
  };
  return /*#__PURE__*/React.createElement(Layer, {
    className: className,
    position: "center",
    onClickOutside: () => setLayer(false),
    onEsc: () => setLayer(false),
    margin: "medium"
  }, /*#__PURE__*/React.createElement(Box, {
    width: size !== 'small' ? '35rem' : '100%'
  }, /*#__PURE__*/React.createElement(LayerHeader, {
    title: title,
    setLayer: setLayer
  }), /*#__PURE__*/React.createElement(Divider, {
    color: "brand"
  }), /*#__PURE__*/React.createElement(Box, {
    overflow: {
      vertical: 'auto',
      horizontal: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(Formik, {
    onSubmit: onSubmit,
    initialValues: {
      files: [],
      file_name: '',
      ext: '',
      croppedAreaPixels: {},
      ...(showAddNotes ? {
        note: initialNote || ''
      } : {})
    },
    enableReinitialize: true
  }, ({
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting
  }) => /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Text, {
    as: "div",
    color: "status-critical"
  }, errors.title), /*#__PURE__*/React.createElement(Box, {
    pad: "medium"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    size: "10px",
    margin: {
      bottom: 'medium'
    }
  }, accept === '' ? fileTypes : `Accepted file types are: ${fileTypes}`), ' ', /*#__PURE__*/React.createElement(UploadComponent, _extends({
    fileTypes: fileTypes,
    accept: accept,
    imageCropAspect: imageCropAspect
  }, rest))), showAddNotes && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(FormField, {
    name: "note",
    error: touched.note && errors.note
  }, /*#__PURE__*/React.createElement(Box, {
    height: "small",
    margin: {
      top: 'small'
    }
  }, /*#__PURE__*/React.createElement(TextArea, {
    fill: true,
    plain: true,
    name: "note",
    resize: false,
    placeholder: "Type here to add notes",
    value: values.note,
    onChange: handleChange,
    onBlur: handleBlur
  })))), /*#__PURE__*/React.createElement(LayerFooter, {
    setLayer: setLayer,
    errors: errors,
    files: values.files,
    isSubmitting: isSubmitting
  })))))));
};
UploadFile.propTypes = {
  accept: PropTypes.string,
  title: PropTypes.string,
  uploadFile: PropTypes.func,
  imageCropAspect: PropTypes.number,
  showAddNotes: PropTypes.bool,
  initialNote: PropTypes.string,
  setLayer: PropTypes.func,
  eventEmitter: PropTypes.object,
  className: PropTypes.string
};
UploadFile.defaultProps = {
  accept: '',
  title: 'Upload File',
  uploadFile: () => alert('FORM SuBMIT'),
  imageCropAspect: null,
  showAddNotes: false,
  initialNote: '',
  setLayer: () => {}
};
export default UploadFile;